import AWSLiveness from "./aws/AWSLiveness";
import IncodeLiveness from "./incode/IncodeLiveness";


function VendorUi({ livenessState, isMobile, onConnectionError }: { livenessState: any; isMobile: boolean; onConnectionError?: () => void }) {
    if (livenessState.data.vendor === 'aws') {
        // overflow:auto (not hidden) keeps the SDK's "Start video check" button
        // reachable via scroll when banner + video + button exceed 100dvh.
        return (
            <div
                className="liveness-container"
                style={{
                    justifyContent: 'center',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    backgroundColor: isMobile ? 'white' : '#f0f0f0',
                    padding: isMobile ? '0' : '20px',
                }}
            >
                <div style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '50%',
                    height: '100dvh',
                    maxHeight: '100dvh',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                    boxShadow: isMobile ? 'none' : '0 4px 6px rgba(255, 255, 255, 0.1)',
                    position: 'relative',
                    margin: 0,
                    padding: 0
                }}>

                    <AWSLiveness livenessSession={livenessState.data.liveness_session} vendorData={livenessState.data.vendor_data} />
                </div>
            </div>
        );
    }
    else if (livenessState.data.vendor === 'incode' || livenessState.data.vendor === 'incode-eu') {
        if (!livenessState.data.vendor_data?.session_id || !livenessState.data.vendor_data?.session_token || !livenessState.data.vendor_data?.interview_id) {
            return (
                <div style={{
                    width: '100%',
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f0f0f0'
                }}>
                    <div style={{ textAlign: 'center', color: '#666' }}>
                        <h2>Configuration Error</h2>
                        <p>Missing required Incode session configuration.</p>
                    </div>
                </div>
            );
        }
        return (
            <IncodeLiveness
                livenessSessionId={livenessState.data.liveness_session}
                sessionId={livenessState.data.vendor_data.session_id}
                sessionToken={livenessState.data.vendor_data.session_token}
                interviewId={livenessState.data.vendor_data.interview_id}
                apiUrl={livenessState.data.vendor_data.api_url}
                onConnectionError={onConnectionError}
            />
        );
    }
    // Return error UI instead of throwing to prevent app crash
    return (
        <div style={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f0f0f0'
        }}>
            <div style={{ textAlign: 'center', color: '#666' }}>
                <h2>Unsupported Vendor</h2>
                <p>The liveness vendor "{livenessState.data.vendor}" is not supported.</p>
            </div>
        </div>
    );
}

export default VendorUi;